var map = {
	"./amchua_bieudo.png": 9283,
	"./caymen_bieudo.png": 2287,
	"./duongdong_bieudo.png": 6844,
	"./khegiua_bieudo.png": 6353,
	"./loading.jpg": 4683,
	"./songluy_bieudo.png": 5931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3922;